{
  "accountPage": {
    "header": {
      "accountTypes": "Rekeningtipes",
      "newUsersSetup": "Nuwe gebruikers sal bygevoeg word as"
    },
    "types": {
      "general": "Algemeen",
      "admin": "Admin",
      "restricted": "Beperk",
      "anonymous": "Anoniem"
    },
    "table": {
      "headers": {
        "accountType": "Rekeningtipe",
        "accessActivity": "Toegang tot Aktiwiteit?",
        "accessSettings": "Toegang tot Instellings?"
      },
      "columns": {
        "restrictedToActivitiesNote": "Beperk tot gedeelde Bates & Groepe",
        "generalToSettingsNote": "Beperk tot Bates & Mense"
      }
    },
    "info": {
      "header": "Rekeningtipes verduidelik",
      "admin": "Ideaal vir werkplekeienaars, senior bestuurders en kantooradministrateurs.",
      "general": "Ideaal vir voltydse personeel en werknemers. (Ons aanbevole verstek.)",
      "restricted": "Ideaal vir bekende besoekers, verskaffers, deeltydse werkers en kontrakteurs wat gedeeltelike of beperkte toegang benodig.",
      "anonymous": "Vir individue wat nie by Gripp geregistreer het nie. Hulle kan slegs Verslae, Notas of Roetines indien gebaseer op wat hulle skandeer."
    },
    "menu": {
      "accountPage": "Rekening",
      "settingsPage": "Instellings",
      "workspaceSettingsPage": "Workspace Instellings"
    },
    "workplaceTitle": "Werkplekbestuur & Data",
    "downloadData": "Laai Data Af",
    "dataExport": {
      "cancel": "Kanselleer",
      "title": "Data Uitvoer",
      "download": "Laai Af"
    }
  },
  "account": {
    "allWorkspaces": "Alle Werkruimtes",
    "create": {
      "button": "Voeg Gebruiker By",
      "form": {
        "email": "E-pos",
        "firstName": "Voornaam",
        "lastName": "Van",
        "role": "Rol"
      },
      "validation": {
        "emailRequired": "E-pos word vereis",
        "role": "Rol word vereis",
        "validEmail": "Voer asseblief 'n geldige e-posadres in"
      }
    },
    "filter": {
      "apply": "Pas Toe",
      "columnSelection": "Kolomme (maks. {{count}})",
      "columns": {
        "createdAt": "Datum Aangesluit",
        "createdDate": "Datum Aangesluit",
        "createdTime": "Tyd Aangesluit",
        "email": "E-pos",
        "groups": "Groepe",
        "jobTitle": "Werkspos",
        "location": "Ligging",
        "name": "Naam (vereis)",
        "phone": "Telefoonnommer",
        "roles": "Rekeningtipe",
        "workspace": "Werkruimte"
      },
      "searchPlaceholder": "Soek naam, nommer of e-pos",
      "columnButton": "Kolomme",
      "groupsButton": "Groepe",
      "accountTypesButton": "Rekeningtipes",
      "noAccountTypes": "Geen Rekeningtipes"
    },
    "groups": {
      "addPeopleTo": "Voeg {{count}} mense by:",
      "addPersonTo": "Voeg 1 persoon by:"
    },
    "list": {
      "accountType": "Rekeningtipe",
      "added": "Datum Aangesluit",
      "createdDate": "Datum Aangesluit",
      "createdTime": "Tyd Aangesluit",
      "email": "E-pos",
      "groups": "Groepe",
      "jobTitle": "Werkspos",
      "location": "Ligging",
      "name": "Naam",
      "phone": "Telefoonnommer",
      "workspace": "Werkruimte"
    },
    "topBar": {
      "peopleSelected": "{{count}} mense gekies",
      "personSelected": "1 persoon gekies"
    },
    "menu": {
      "confirmDelete": {
        "primaryButton": "Ja",
        "secondaryButton": "Kanselleer",
        "title": "Is jy seker jy wil {{accountName}} verwyder?"
      }
    }
  },
  "activity": {
    "filter": {
      "cancel": "Kanselleer",
      "groups": "Groepe",
      "activityOptions": "Aktiwiteitsopsies",
      "activityTypes": "Aktiwiteittipes",
      "options": "Opsies",
      "types": "Tipes",
      "notes": "Notas",
      "pending": "Hangend",
      "reset": "Herstel",
      "routines": "Roetines",
      "searchPlaceholder": "Soek aktiwiteittitels of batenaam",
      "searchLabels": "Soek etikette",
      "solved": "Opgelos",
      "title": "Filters",
      "labels": "Etikette",
      "urgent": "Dringend",
      "date": "Datum",
      "all": "Alles",
      "day": "dag",
      "week": "week",
      "month": "maand",
      "today": "Vandag",
      "thisWeek": "Afgelope 7 dae",
      "thisMonth": "Afgelope 30 dae",
      "custom": "Pasgemaak",
      "customDate": "Pasgemaakte Datum",
      "from": "Vanaf",
      "to": "Tot",
      "mentions": "Vermeldings",
      "scheduled": "Geskeduleer",
      "default": "Verstek",
      "notScheduled": "Nie geskeduleer",
      "pinned": "Vasgepen",
      "everything": "Alles",
      "onlyMentions": "Slegs vermeldings",
      "onlyPinned": "Slegs vasgepende",
      "onlyScheduled": "Slegs geskeduleerde",
      "sort": "Sorteer",
      "viewResults": "Bekyk {{count}} resultate"
    },
    "search": {
      "title": "Soek",
      "search": "Soek",
      "recentSearches": "Onlangse Soektogte"
    },
    "header": {
      "title": "Aktiwiteit",
      "view": "Bekyk",
      "viewAll": "Bekyk Alles"
    },
    "list": {
      "youAreMentioned": "Jy word genoem."
    },
    "menu": {
      "title": "Aktiwiteit",
      "titlePlural": "Aktiwiteite"
    },
    "textEmpty": "Geen aktiwiteit",
    "topBar": {
      "results": "resultate"
    },
    "sort": {
      "mostRecent": "Laaste opdatering",
      "reminderDate": "Herinneringsdatum",
      "oldest": "Skeppingsdatum"
    },
    "tapScan": "Tik '+' om bates of uitnodigingskodes te skandeer.",
    "messageBubble": {
      "joinWorkspace": {
        "title": "Sluit by 'n werkruimte aan!",
        "description": "Jy is nog nie in 'n werkruimte nie.\nSkandeer 'n uitnodigingskode om by 'n\nwerkruimte aan te sluit!"
      },
      "addActivity": {
        "title": "Voeg Aktiwiteit By",
        "description": "Jy het nog geen aktiwiteit nie.\nTik '+' om 'n verslag of nota oor jou bate by te voeg en jou span ingelig te hou."
      },
      "addAsset": {
        "title": "Voeg Bates By",
        "description": "Jy het nog geen bates nie.\nTik '+' om te skandeer en jou eerste bate by te voeg om te begin."
      },
      "or": "of",
      "newSub": "begin 'n nuwe intekening",
      "here": "hier"
    }
  },
  "admin": {
    "menu": {
      "admin": "Mense",
      "workspaces": "Werkruimtes"
    }
  },
  "alerts": {
    "addAnother": "Voeg nog een by",
    "create": {
      "alertName": "Waarskuwing Naam",
      "asset(s)": "Bate(s)",
      "assetSearchPlaceholder": "Soek 'n batenaam",
      "assets": "Bates",
      "doNotAlert": "<0>(Opsioneel)</0><1>Moenie waarsku tussen:</1>",
      "groupSearchPlaceholder": "Soek 'n groepnaam",
      "groups": "Groepe",
      "promptRoutine": "<0>(Opsioneel)</0><1>Kies 'n roetine</1><0>om met hierdie waarskuwing te vra:</0>",
      "promptRoutinePlaceholder": "geen roetine gekies",
      "title": "Skep Waarskuwing",
      "what": "1. Kies wat:",
      "when": "3. Kies wanneer:",
      "why": "2. Kies waarom:"
    },
    "setAlert": "Stel waarskuwing in",
    "setANewAlert": "Stel 'n nuwe waarskuwing in",
    "createButton": "Skep Nuwe",
    "createNewAlert": "Skep 'n Nuwe Waarskuwing",
    "createAlert": "Skep Waarskuwing",
    "alert": "Waarskuwing",
    "alerts": "Waarskuwings",
    "deleteAlert": "Skrap Waarskuwing",
    "nextAlert": "Volgende Waarskuwing: ",
    "lastAlert": "Laaste Waarskuwing: ",
    "lastAlertNA": "N/V",
    "confirm": "Bevestig",
    "currently": "Tans: ",
    "abovePlaceholder": "bo",
    "belowPlaceholder": "onder",
    "editAlert": "Wysig Waarskuwing",
    "intervalValue": "Intervalwaarde",
    "newAlert": "Nuwe Waarskuwing",
    "number": "Nommer",
    "minDropdownPlaceholder": "Wanneer dit bo is  _____ ",
    "maxDropdownPlaceholder": "Wanneer dit onder is  _____ ",
    "setAlertLogic": "Stel Waarskuwingslogika",
    "setAlertLogicPlaceholder": "Kies 'n waarskuwingslogika",
    "optionalSettings": "Opsionele Instellings",
    "customLabelTitle": "Pasgemaak waarskuwingstitel",
    "blackoutDates": "Swartoutdatums?",
    "startDate": "Begindatum",
    "starting": "Begin",
    "day": "dag",
    "days": "dae",
    "togo": "oor",
    "completions": "voltooiings",
    "recorded": "aangeteken",
    "elapsed": "verstreke",
    "OR": "OF",
    "or": "of",
    "on": "op",
    "skipped": "oorgeslaan",
    "every": "elke",
    "Every": "Elke",
    "startingValue": "Beginwaarde",
    "onDate": "Op 'n spesifieke datum",
    "onDays": "Elke ___ dae",
    "onDayInterval": "Herinner my na ___",
    "onDayIntervalUnit": "Interval",
    "dateInterval": {
      "minutes": "Minute",
      "hours": "Ure",
      "days": "Dae",
      "weeks": "Weke",
      "months": "Maande"
    },
    "onDaysSkipped": "Elke ___ dae roetine is onvolledig",
    "onRoutineCompletions": "Elke ___ keer roetine voltooi",
    "onInterval": "Gebaseer op 'n interval",
    "selectRoutineToPrompt": "Kies Roetine om te Vra",
    "selectAlertingLogic": "Kies Waarskuwingslogika",
    "customLabelWhenAlertOccurs": "Pasgemaak Etiket Wanneer Waarskuwing Voorkom",
    "selectRoutine": "Kies roetine",
    "reset": "Herstel",
    "edit": {
      "alertName": "Waarskuwing Naam",
      "asset(s)": "Bate(s)",
      "assets": "Bates",
      "doNotAlert": "Moenie waarsku tussen",
      "groups": "Groepe",
      "none": "Geen",
      "promptRoutine": "<0>Kies 'n roetine</0><1>om met hierdie waarskuwing te vra</1>",
      "promptRoutinePlaceholder": "geen roetine gekies",
      "setFor": "Hierdie waarskuwing is ingestel vir",
      "setOn": "Stel die waarskuwing op",
      "title": "Wysig Waarskuwing",
      "when": "Wanneer"
    },
    "menu": {
      "confirmDelete": {
        "primaryButton": "Ja",
        "secondaryButton": "Kanselleer",
        "title": "Is jy seker jy wil {{alertName}} skrap?"
      },
      "delete": "Skrap",
      "disableAlert": "Deaktiveer Waarskuwing",
      "enableAlert": "Aktiveer Waarskuwing",
      "viewAlertActivities": "Bekyk Waarskuwingsaktiwiteite"
    },
    "new": {
      "header": "Waarskuwings > Skep Waarskuwing"
    },
    "title": "Outomatisering",
    "trigger": {
      "counter": {
        "ceiling": "Die teller gaan bo",
        "daysSinceCompleted": "Die roetine is nie voltooi nie vir",
        "daysSinceCompleted-end": "Dae",
        "every": "Elke",
        "every-end": "Dae",
        "floor": "Die teller gaan onder",
        "onCompletionCount": "Die roetine is voltooi elke",
        "onCompletionCount-end": "Keer",
        "onInterval": "Die teller bereik interval van"
      },
      "default": {
        "daysSinceCompleted": "Die roetine is nie voltooi nie vir",
        "daysSinceCompleted-end": "Dae",
        "every": "Elke",
        "every-end": "Dae",
        "onCompletionCount": "Die roetine is voltooi elke",
        "onCompletionCount-end": "Keer"
      }
    },
    "validation": {
      "alertTypeRequired": "Waarskuwingstipe word vereis",
      "inputRequired": "Invoer word vereis",
      "invalidDate": "Ongeldige datum",
      "startDateRequiredForDays": "Begindatum word vereis vir Dae waarskuwingstipe",
      "routineIdRequiredForInterval": "Roetine id word vereis vir interval"
    },
    "setInterval": "Stel interval",
    "numberOfDays": "Aantal dae",
    "numberOfTimes": "Aantal kere"
  },
  "asset": {
    "advancedAssetInformation": "Gevorderde Bate Inligting",
    "customAlert": {
      "tagAlreadyAdded": "Hierdie etiket is reeds by hierdie bate gevoeg.",
      "tryAnotherTag": "Hierdie Etiket is reeds in gebruik en kan nie gekies word nie, probeer asseblief 'n ander etiket."
    },
    "delete": {
      "button": "Skrap Bate",
      "cancel": "Kanselleer",
      "confirm": "Skrap",
      "title": "Is jy seker jy wil hierdie bate skrap?"
    },
    "description": "Beskrywing",
    "descriptionPlaceholder": "Opsioneel",
    "details": "Besonderhede",
    "detailsPlaceHolder": "Opsioneel",
    "editTitle": "Bate Inligting",
    "groups": "Groepe",
    "groupsPlaceHolder": "(Opsioneel) Kies Groep(e)",
    "groupsSearchPlaceHolder": "Soek 'n groepnaam",
    "header": {
      "buttons": {
        "addNew": "Voeg Verslag / Nota By",
        "routines": "Roetines",
        "addSomething": "Voeg iets by"
      },
      "recentActivity": "Onlangse Aktiwiteit"
    },
    "information": "Bate Inligting",
    "mediaLibrary": "Mediabiblioteek",
    "name": "Naam",
    "namePlaceholder": "Wat is dit?",
    "newIssue": "Iets nuuts?",
    "newTitle": "Bate Opstelling",
    "tagCode": "Gripp ID",
    "assetPicture": "Neem 'n foto van die bate",
    "assetName": "Gee dit 'n naam",
    "newAdditionalMedia": "Enige bykomende foto's om op te laai? (databorde, oem-plakkers, ens.)",
    "secondaryDescription": "Enige sekondêre beskrywing?",
    "optionalSetting": "Opsionele Instellings",
    "hideReportAndNoteOptionsAnonymous": "Versteek Verslag & Nota opsies vir anonieme besoekers",
    "files": {
      "title": "Lêers",
      "noFiles": "Geen lêers gevind nie.",
      "addFilesLinks": "Voeg lêers / skakels by",
      "save": "Stoor",
      "addFile": "Voeg lêer by",
      "view": "Beskou {{count}} resultaat",
      "view_plural": "Beskou {{count}} resultate",
      "camera": "Kamera"
    },
    "detail": {
      "edit": "Wysig",
      "delete": "Skrap",
      "delete_asset": "Skrap Bate",
      "delete_warning": "Hierdie aksie kan nie ongedaan gemaak word nie.",
      "confirmDelete": "Is jy seker jy wil die lêer {{fileName}} skrap?"
    },
    "productType": "Produktipe",
    "serialNumber": "Reeksnommer",
    "addons": "Byvoegings ({{count}})",
    "addonsNoProduct": "Hierdie bate het geen produk tipe nie. Ken 'n produk toe om byvoeging keuse moontlik te maak.",
    "enterTagCode": "Voer Etiketkode In",
    "add": "Voeg By",
    "cancel": "Kanselleer",
    "save": "Stoor",
    "tagCodePlaceholder": "Voer etiketkode in",
    "lookingUpTag": "Soek etiket...",
    "pinnedActivity": "Vasgepen Aktiwiteit",
    "viewAll": "Bekyk Alles"
  },
  "assets": {
    "filter": {
      "title": "Filters",
      "search": "Soek",
      "recentSearches": "Onlangse Soektogte",
      "apply": "Pas Toe",
      "reset": "Herstel",
      "viewResults": "Bekyk {{count}} resultate",
      "columnButton": "Kolomme",
      "columnSelection": "Kolomme",
      "columns": {
        "createdAt": "Geskep Op",
        "createdBy": "Geskep Deur",
        "description": "Beskrywing",
        "productName": "Produk Naam",
        "groups": "Groepe",
        "lastAddress": "Ligging",
        "lastScannedAt": "Laaste Geskandeer",
        "lastUpdated": "Laaste Opgedateer",
        "name": "Naam (vereis)",
        "notes": "# Notas",
        "alerts": "# Waarskuwings",
        "reports": "# Aktiewe Verslae",
        "routines": "# Roetines",
        "addons": "# Byvoegings",
        "tagCode": "Gripp ID",
        "workspaces": "Werkspasie"
      },
      "groups": "Groepe",
      "groupsButton": "Groepe",
      "default": "Verstek",
      "searchPlaceholder": "Soek naam, beskrywing, produk, add-ons of Gripp ID",
      "filterToggle": "Kombinasie filter:"
    },
    "groups": {
      "addAssetTo": "Voeg 1 bate by:",
      "addAssetsTo": "Voeg {{count}} bates by:"
    },
    "list": {
      "createdAt": "Geskep Op",
      "createdDate": "Geskep Datum",
      "createdTime": "Geskep Tyd",
      "createdBy": "Geskep Deur",
      "description": "Beskrywing",
      "productName": "Produk Naam",
      "groups": "Groepe",
      "lastAddress": "Ligging",
      "lastScannedAt": "Laaste Geskandeer",
      "lastScannedDate": "Laaste Geskandeer Datum",
      "lastScannedTime": "Laaste Geskandeer Tyd",
      "lastUpdated": "Laaste Opgedateer",
      "lastUpdatedDate": "Laaste Opgedateer Datum",
      "lastUpdatedTime": "Laaste Opgedateer Tyd",
      "name": "Naam",
      "notes": "Notas",
      "alerts": "Waarskuwings",
      "reports": "Aktiewe Verslae",
      "routines": "Roetines",
      "addons": "Byvoegings",
      "tagCode": "Gripp ID",
      "workspaces": "Werkspasie"
    },
    "menu": {
      "title": "Bates",
      "titleSingular": "Bate"
    },
    "textEmpty": "Geen bates",
    "topBar": {
      "allAssets": "Alle Bates",
      "assetSelected": "1 bate gekies",
      "assetsSelected": "{{count}} bates gekies",
      "results": "{{count}} resultate"
    },
    "change": "Verander",
    "routines": "Roetines",
    "routineSearchPlaceholder": "Soek roetienaam",
    "addonsSearchPlaceholder": "Soek byvoeging naam"
  },
  "products": {
    "textEmpty": "Geen produkte",
    "list": {
      "name": "Naam"
    }
  },
  "avatar": {
    "menu": {
      "profile": "Profiel"
    }
  },
  "binaryCheck": {
    "button": "Dateer Op",
    "instructions1": "'n Nuwe opdatering is beskikbaar!",
    "instructions2": "Gripp mag nie werk tot dan nie."
  },
  "camera": {
    "Cancel": "Kanselleer",
    "grippInviteDetected": "Gripp Uitnodiging Bespeur!",
    "grippTagDetected": "Gripp Etiket Bespeur!",
    "noCameraAccess": "Geen toegang tot kamera",
    "notGrippInvite": "Nie 'n Gripp Uitnodiging",
    "notGrippTagg": "Nie 'n Gripp Etiket",
    "tryAgain": "Probeer Asseblief Weer",
    "noPermissionModal": {
      "oopsMessage": "Oeps! Jy het nie toestemming om\ntoegang tot hierdie Gripp etiket te kry nie. 🙈",
      "button": "Ek het dit!",
      "errorMessage": "As jy glo dit is 'n fout, bevestig dat jy\ntot die korrekte werkplek genooi is of\nkontak Gripp ondersteuning."
    }
  },
  "changesSaved": "Veranderinge Gestoor",
  "common": {
    "back": "Terug",
    "cancel": "Kanselleer",
    "create": "Skep",
    "download": "Laai Af",
    "reset": "Herstel",
    "apply": "Pas Toe",
    "save": "Stoor",
    "optional": "Opsioneel",
    "value": "Waarde",
    "delete": "Skrap",
    "next": "Volgende",
    "remove": "Verwyder",
    "typeMessage": "Tik 'n boodskap...",
    "filter": "Filter"
  },
  "customAlert": {
    "ok": "OK"
  },
  "deleteAccount": {
    "button": "Skrap rekening",
    "cannotUndone": "Hierdie aksie kan nie ongedaan gemaak word nie.",
    "confirm": "Bevestig Skrap",
    "header": "Skrap Rekening",
    "reasonInput": "Laat ons asseblief weet van enige bykomende besonderhede vir die skrap van jou rekening (opsioneel):",
    "reasonInputNoOptional": "Laat ons asseblief weet van enige bykomende besonderhede vir die skrap van jou rekening:",
    "submitted": "Jou rekening skrap versoek is ingedien."
  },
  "dropdown": {
    "dropdownFooter": {
      "apply": "Pas Toe",
      "reset": "Herstel"
    }
  },
  "edit": "",
  "email": "E-pos",
  "features": {
    "title": "Kenmerke",
    "assignment": {
      "workspaces": "Werkruimtes",
      "accounts": "Rekeninge",
      "workspaceSearchPlaceholder": "Soek werkruimtes...",
      "accountSearchPlaceholder": "Soek rekeninge...",
      "noWorkspaces": "Geen werkruimtes gevind nie",
      "noAccounts": "Geen rekeninge gevind nie",
      "name": "Naam",
      "email": "E-pos",
      "phone": "Telefoon"
    }
  },
  "firstName": "Voornaam",
  "forbidden": "Verbode",
  "groups": {
    "groupsSelector": {
      "addToGroup": "Voeg by Groep",
      "addtoNewGroup": "Voeg by Nuwe Groep",
      "apply": "Pas Toe",
      "clearGroups": "Maak Groepe Skoon"
    },
    "searchGroups": "Soek groepe",
    "noGroups": "Geen Groepe",
    "menu": {
      "title": "Groepe",
      "editGroup": "Wysig Groep"
    },
    "create": {
      "label": "Skep 'n Nuwe Groep",
      "validation": {
        "name_required": "Groepnaam is vereis"
      },
      "create": "Skep",
      "placeholder": "bv. Groep Trekkers"
    },
    "list": {
      "name": "Groepnaam",
      "people": "Mense",
      "assets": "Bates",
      "reports": "Aktiewe Verslae",
      "routines": "Roetines",
      "assetAlerts": "Bate Waarskuwings",
      "groupAlerts": "Groep Waarskuwings"
    },
    "common": {
      "textEmpty": "Geen groep",
      "selectGroup": "Kies groepe",
      "searchGroup": "Soek groepe",
      "createGroup": "Skep Groep",
      "emptyStateMessage": "Skep 'n groep deur direk in die soekbalk te tik."
    },
    "filter": {
      "searchPlaceholder": "Soek groepname",
      "columnButton": "Kolomme",
      "columns": {
        "name": "Groepnaam",
        "reports": "Aktiewe Verslae",
        "assets": "Bates",
        "people": "Mense",
        "routines": "Roetines",
        "assetAlerts": "Bate Waarskuwings",
        "groupAlerts": "Groep Waarskuwings"
      },
      "columnSelection": "Kolomme"
    },
    "assignments": {
      "name": "Naam",
      "jobTitle": "Werktitel",
      "accountType": "Rekeningtipe",
      "assetSearchPlaceholder": "Soek batenaam, beskrywing, of groepnaam",
      "accountSearchPlaceholder": "Soek persoon se naam of titel",
      "routineSearchPlaceholder": "Soek roetienaam",
      "groupSearchPlaceholder": "Soek groepname",
      "addonsSearchPlaceholder": "Soek byvoeging naam",
      "emptyAccountList": "Geen rekeninge",
      "assets": "Bates",
      "people": "Mense",
      "routines": "Roetines"
    },
    "deleteGroup": {
      "deleteGroup": "Skrap Groep",
      "alertBody1": "Is jy seker jy wil skrap",
      "alertBody2": "Let wel: ",
      "alertBody3": "Dit sal nie enige bates wat met hierdie ",
      "alertBody4": "groep geassosieer is skrap nie.",
      "delete": "Skrap",
      "cancel": "Kanselleer"
    }
  },
  "help": {
    "menu": {
      "title": "Hulp"
    }
  },
  "alertsManagement": {
    "menu": {
      "title": "Waarskuwings",
      "editAlert": "Wysig waarskuwing"
    },
    "filter": {
      "searchPlaceholder": "Soek waarskuwings...",
      "columnButton": "Kolomme",
      "columnSelection": "Kolomkeuse",
      "columns": {
        "name": "Naam",
        "routineName": "Roetine",
        "assetName": "Bate",
        "groupName": "Groep",
        "productName": "Produk",
        "assetAlerts": "Bate-waarskuwings",
        "lastAlertDate": "Laaste waarskuwing",
        "nextAlertDate": "Volgende waarskuwing",
        "createdAt": "Geskep",
        "status": "Status"
      },
      "status": {
        "label": "Status",
        "all": "Alles",
        "enabled": "Geaktiveer",
        "disabled": "Gedeaktiveer"
      }
    },
    "common": {
      "textEmpty": "Geen waarskuwings gevind nie"
    },
    "list": {
      "name": "Naam",
      "routineName": "Roetine",
      "assetName": "Bate",
      "groupName": "Groep",
      "productName": "Produk",
      "assetAlerts": "Bate-waarskuwings",
      "lastAlertDate": "Laaste waarskuwing",
      "nextAlertDate": "Volgende waarskuwing",
      "createdAt": "Geskep",
      "status": "Status"
    },
    "deleteAlert": {
      "deleteAlert": "Verwyder waarskuwing",
      "alertBody1": "Is jy seker jy wil verwyder",
      "alertBody2": "Waarskuwing:",
      "alertBody3": " Die verwydering van hierdie waarskuwing sal dit permanent verwyder saam met al die geassosieerde data.",
      "delete": "Verwyder",
      "cancel": "Kanselleer"
    },
    "actions": {
      "enable": "Aktiveer",
      "disable": "Deaktiveer",
      "enableSuccess": "{count} waarskuwing(s) suksesvol geaktiveer",
      "disableSuccess": "{count} waarskuwing(s) suksesvol gedeaktiveer"
    }
  },
  "invitation": {
    "initial": {
      "heading": "Jy word genooi na {{workspaceName}}!",
      "login": "Teken In Sleutel",
      "step1": "Stap 1",
      "step1Instructions": "Laai Gripp toep af",
      "step2": "Stap 2",
      "step2Instructions": "Gebruik hierdie sleutel om aan te meld"
    },
    "invitePeople": {
      "copiedInvitationLink": "Uitnodigingskakel gekopieer",
      "copyInviteLink": "Kopieer uitnodigingskakel",
      "errorCopyingInvitationLink": "Iets het verkeerd gegaan toe die uitnodigingsurl gekopieer is",
      "invitePeopleForm": "Nooi mense deur e-posse",
      "invitePeopleQR": "Nooi mense deur QR-kode",
      "linkAllowsToJoinWorkplace": "Hierdie skakel laat enigiemand toe om te vra om by jou werkplek aan te sluit.",
      "placeholder": "E-posse",
      "submit": "Dien In",
      "to": "Aan"
    },
    "pending": {
      "accepted": "Volg die skakel wat na jou e-pos gestuur is om by jou Gripp Rekening aan te meld.",
      "cancel": "Kanselleer",
      "join": "Sluit Aan",
      "joining": "Jy sluit aan by {{workspaceName}}",
      "title": "Skep Profiel"
    },
    "qr": {
      "invitesYou": "nooi jou om aan te sluit",
      "showQr": "Wys QR om ander uit te nooi"
    }
  },
  "issue": {
    "anonymous": {
      "addNote": "Voeg Nota By",
      "createReport": "Skep Verslag",
      "noteAdded": "Behoorlik Genoteer!",
      "noteAddedDownloadGrippApp": "Laai die Gripp toep af vir selfs makliker notulering!",
      "report": "Verslag",
      "reportAddedDownloadGrippApp": "Laai die Gripp toep af vir selfs vinniger verslagdoening!",
      "reported": "Kwessie Gerapporteer!",
      "routineCompleted": "Boom, opdatering bevestig!",
      "routineCompletedDownloadGrippApp": "Laai die Gripp toep af vir die gladste ervaring!"
    },
    "common": {
      "addPicture": "Foto's",
      "description": "Beskrywing",
      "followUp": "Opvolg vereis?",
      "note": "Nee, net vir verwysing",
      "report": "Ja, opvolg nodig",
      "addLabel": "Voeg 'n Etiket By",
      "labelSubtitle": "Vir makliker soek & filter.",
      "selectLabel": "Kies 'n etiket",
      "searchLabel": "Soek 'n etiket",
      "createLabel": "Skep etiket",
      "emptyStateMessage": "Skep 'n etiket deur direk in die soekbalk te tik.",
      "labelsApplied": "Etikette toegepas"
    },
    "delete": {
      "confirm": "Bevestig skrap?"
    },
    "editModal": {
      "header": "Wysig",
      "save": "Stoor",
      "reviseSubmission": "Hersien Indiening"
    },
    "latestMessage": {
      "media": "[Media]"
    },
    "menu": {
      "delete": "Skrap",
      "edit": "Wysig",
      "editRoutine": "Wysig Roetine",
      "pinToAsset": "Vaspen aan Bate",
      "print": "Druk",
      "reassign": "Herwys",
      "reminder": "Herinnering",
      "unpin": "Ontpen",
      "unpinToAsset": "Ontpen van Bate"
    },
    "new": {
      "addIt": "Voeg Verslag / Nota By",
      "editActivity": "Wysig Aktiwiteit",
      "labels": "Etikette",
      "optionalPlaceholder": "Opsioneel",
      "placeholder": "Wat sien jy?",
      "reassign": "Herwys",
      "reminder": "Herinnering",
      "submit": "Dien In",
      "title": "Titel",
      "type": "Tipe"
    },
    "quickReminder": {
      "header": "Stel Herinnering",
      "subheader": "Om hierdie verslag vir 'n toekomstige datum te skeduleer."
    },
    "adjustCreationDate": {
      "header": "Pas Skeppingsdatum Aan"
    },
    "createdDate": {
      "header": "Geskep Datum"
    },
    "types": {
      "attention": "Dringend",
      "urgent": "Dringend",
      "blocker": "Hangend",
      "pending": "Hangend",
      "done": "Opgelos",
      "solved": "Opgelos",
      "routines": "Roetines",
      "note": "Nota",
      "campaign": "Veldtog"
    },
    "advancedSettings": "Gevorderde Instellings",
    "dateFormat": "MM/DD/YYYY",
    "reminderFor": "Herinnering vir:",
    "reassign": {
      "instructions": "Aan watter een van die volgende bates wil jy herwys?",
      "placeholder": "Soek 'n batenaam",
      "saveLabel": "Stoor",
      "title": "Herwys"
    },
    "topBar": {
      "allReplies": "antwoorde"
    },
    "reminder": {
      "notesOptional": "Notas (Opsioneel)",
      "scheduled": "Geskeduleerde Herinnering"
    }
  },
  "job": "",
  "jobTitle": "Werktitel",
  "lastName": "Van",
  "loading": "Laai",
  "login": {
    "codeSentTo": "'n Aanmeldkode is gestuur na",
    "email": "E-pos",
    "error": {
      "invalidCredentials": "Ongeldige geloofsbriewe",
      "processError": "Daar was 'n fout met die verwerking van jou versoek"
    },
    "login": "Teken in",
    "password": "Wagwoord",
    "resendCode": "Stuur kode weer",
    "tabs": {
      "new": {},
      "returning": {
        "title": "Ek kom terug"
      }
    },
    "tryAnotherMethod": "Probeer 'n ander metode",
    "withEmail": "Gaan voort met E-pos",
    "withPassword": "Ek het 'n wagwoord",
    "withPhone": "Gaan voort met Telefoon",
    "continue": "Gaan Voort",
    "skip": "Slaan Oor",
    "smsConfirmationMessage": "Ons sal SMS om jou nommer te bevestig. Dit mag 'n paar sekondes neem.",
    "emailConfirmationMessage": "Ons sal 'n verifikasiekode stuur om jou e-pos te bevestig. Dit mag 'n paar sekondes neem.",
    "aboutYourself": "Vertel ons meer van jouself!",
    "existingAccount": "Het jy reeds 'n Gripp rekening?"
  },
  "logout": "Teken Uit",
  "errorBoundary": {
    "title": "Oeps!",
    "message": "'n Onverwagte fout het voorgekom.",
    "tryAgain": "Probeer weer"
  },
  "mentions": {
    "unknownUser": "Onbekende Gebruiker",
    "youAreMentioned": "Jy word genoem"
  },
  "modalMessages": {
    "completed": "Voltooi"
  },
  "or": "of",
  "onboarding": {
    "shareInfo": "Deel meer met Gripp oor jou!",
    "industrial": "Nywerheidsveld",
    "source": "Hoe het jy van Gripp gehoor?",
    "agriculture": "Landbou"
  },
  "people": {
    "menu": {
      "people": "Mense"
    }
  },
  "phone": "Telefoonnommer",
  "plusMenu": {
    "add-asset": "Voeg Bate By",
    "invite": "Nooi",
    "no-tag": "Geen Etiket?",
    "note": "Nota",
    "report": "Verslag",
    "scan": "Skandeer"
  },
  "preferences": {
    "language": {
      "languages": {
        "english": "Engels",
        "spanish": "Spaans",
        "russian": "Russies",
        "kazakh": "Kazakhs",
        "afrikaans": "Afrikaans",
        "portuguese": "Portugees",
        "french": "Frans"
      },
      "language": "Taal",
      "preferredLanguageTitle": "Voorkeurtaal"
    },
    "menu": {
      "title": "Instellings"
    },
    "settings": {
      "notifications": "Kennisgewings",
      "profile": "Profiel",
      "title": "Instellings",
      "workSpaces": "Werkruimtes",
      "workspace_settings": "Werkruimte-instellings"
    },
    "notifications": {
      "activityLabelNotificationsTitle": "Aktiwiteit-etiket kennisgewings",
      "groupNotificationsTitle": "Groep Kennisgewings",
      "issueReplies": "Boodskappe",
      "notificationTitle": "Kennisgewings",
      "schedule": {
        "accept": "Aanvaar",
        "cancel": "Kanselleer",
        "endTime": "Eindtyd:",
        "everyDay": "Elke Dag",
        "notSet": "Nie gestel nie",
        "notificationSchedule": "Kennisgewing Skedule",
        "set": "Stel",
        "startTime": "Begintyd:",
        "weekDays": "Weeksdae"
      },
      "severities": {
        "blue": "Nuwe Roetines",
        "purple": "Nuwe Notas",
        "red": "Nuwe Verslae"
      }
    }
  },
  "profile": {
    "edit": {
      "menu": {
        "title": "Wysig Profiel"
      },
      "impersonate": {
        "impersonate": "Voorgedoen",
        "unimpersonate": "Kanselleer Voorgedoen"
      },
      "error": {
        "title": "Fout met die opdatering van profiel",
        "generic": "Daar was 'n fout met die opdatering van jou profiel. Probeer asseblief weer.",
        "duplicatedPhone": "Hierdie telefoonnommer is reeds aan 'n ander rekening gekoppel."
      }
    },
    "admin": {
      "title": "Impersonation",
      "workspace": "Werkspasie",
      "workspaceUsers": "Werkspasie Gebruikers"
    }
  },
  "recent_activities": "Onlangse Aktiwiteite",
  "reminders": {
    "deleteReminder": "Skrap Herinnering",
    "setNewReminder": "stel 'n nuwe herinnering vir"
  },
  "requestRoutine": {
    "apply": "Pas Toe",
    "header": "Roetine",
    "instruction": "Dien asseblief jou roetine idee in:",
    "placeHolder": "Wat moet ons begin doen?"
  },
  "routines": {
    "admin": {
      "create": "Stoor",
      "instructions": "Instruksies",
      "issuePrefix": "Kwessie Voorvoegsel",
      "reportOnException": "Rapporteer op Uitsondering?",
      "routineButtonText": "Roetine Knoppie",
      "title": "Titel",
      "type": "Tipe",
      "oneTimeOnly": "Slegs een keer",
      "autoPrompt": "Outomatiese aansporing by bate-opening",
      "update": "Dateer Op",
      "addMedia": "Voeg Media By",
      "image": "Beeld",
      "link": "Skakel",
      "linkLabel": "Voeg Skakel By",
      "linkUrl": "Skakel URL",
      "linkUrlPlaceholder": "Voer URL in (bv., https://example.com)",
      "invalidUrl": "Ongeldige URL",
      "enableAutoPinning": "Skakel outomatiese vaspen aan",
      "autoAddLabel": "Voeg outomaties 'n etiket by"
    },
    "assign": "Wys Roetines Toe",
    "copyToWorkspace": {
      "save": "Kopieer",
      "title": "Kopieer na Werkspasie",
      "workspace": "Werkspasie"
    },
    "counter": {
      "admin": {
        "decimalPlaces": "Aktiveer Desimale (Opsioneel)",
        "tallyCounter": "Teltoonbank",
        "uom": "Eenheid van Meting",
        "counterType": "Teltoonbank Tipe"
      },
      "user": {
        "genericCounter": {
          "change": "Verander:",
          "initialValue": "Aanvanklike Waarde:",
          "newValue": "Nuwe Waarde:"
        },
        "tallyCounter": {
          "add": "+ Voeg By",
          "added": "Bygevoeg",
          "adding": "Voeg By:",
          "instructions": "",
          "newValue": "Nuwe Waarde:",
          "oldValue": "Ou Waarde:",
          "placeholder": "Voer nommer in...",
          "remove": "- Verwyder",
          "removed": "Verwyder",
          "removing": "Verwyder:"
        }
      },
      "counterTypes": {
        "SIMPLE": "Eenvoudig",
        "CUMULATIVE": "Kumulatief",
        "TALLY": "Tel"
      }
    },
    "time": {
      "admin": {
        "time": "Tyd tipe",
        "labelStartTime": "Begintyd",
        "labelEndTime": "Eindtyd"
      },
      "timeTypes": {
        "START_END_TIMES": "Begin en eindtye",
        "TIME_ONLY": "Slegs tyd",
        "DATE_ONLY": "Slegs datum"
      },
      "message": {
        "time": "Tyd",
        "start": "Begin",
        "end": "Einde",
        "date": "Datum"
      }
    },
    "createNew": "Skep 'n Roetine",
    "edit": {
      "header": "Roetines > Wysig Roetine"
    },
    "editRoutines": {
      "editRoutinesButton": "Wysig Roetines",
      "label": "Etiket: ",
      "routineInWorkplace": "Alle roetines beskikbaar in jou werkplek",
      "title": "Wysig",
      "saveSuccess": "Roetines suksesvol opgedateer",
      "saveError": "Kon nie roetines stoor nie",
      "routineAdded": "Die roetine {{title}} is bygevoeg",
      "routineRemoved": "Die roetine {{title}} is verwyder",
      "routineReordered": "Roetines suksesvol herrangskik"
    },
    "exceptions": {
      "addDetails": "Voeg asseblief bykomende besonderhede of foto's van die kwessie by:",
      "exceptionsNoticed": "{{count}} uitsondering opgemerk",
      "exceptionsNoticed_plural": "{{count}} uitsonderings opgemerk",
      "reportCreated": "'n Verslag is geskep",
      "viewRelatedReport": "Bekyk Verwante Verslag",
      "viewRelatedRoutine": "Bekyk Verwante Roetine"
    },
    "header": {
      "title": "Roetines",
      "view": "Bekyk",
      "viewAll": "Bekyk Alles"
    },
    "menu": {
      "copyToWorkspace": "Kopieer na Werkspasie",
      "delete": {
        "cancel": "Kanselleer",
        "confirm": "Ja",
        "item": "Skrap",
        "title": "Is jy seker jy wil hierdie roetine skrap?"
      },
      "download": "Laai Af",
      "editRoutine": "Wysig Roetine",
      "export": "Voer data uit",
      "exporting": "Voer uit..."
    },
    "message": {
      "messageTitle": "{{name}} het roetine voltooi:",
      "added": "bygevoeg",
      "removed": "verwyder",
      "originalValue": "Oorspronklike Waarde",
      "newValue": "Nuwe Waarde",
      "messageTitleUpdated": "{{name}} het 'n opdatering gemaak"
    },
    "modalCancel": {
      "primary": "Gaan uit sonder om te stoor.",
      "secondary": "Kanselleer",
      "title": "Voordat ons teruggaan,"
    },
    "draftModal": {
      "continueDraft": "Gaan voort met konsep.",
      "startNew": "Begin 'n nuwe roetine.",
      "cancel": "Kanselleer",
      "messageNoDraft": "'n Konsep is gestoor",
      "messageWithoutCreator": "'n Konsep is gestoor op {{date}}",
      "messageWithCreator": "'n Konsep is gestoor deur: \n{{creator}} op {{date}}"
    },
    "new": {
      "chooseTypeButton": "Volgende Stap: Kies Opsies",
      "header": "Roetines > Skep Roetine"
    },
    "quickConfirm": {
      "admin": {
        "addOption": "Voeg opsie by",
        "options": "Opsies"
      }
    },
    "requestButton": "+ Versoek Roetine",
    "signature": {
      "clear": "Maak Skoon",
      "done": "Klaar",
      "sign": "Teken",
      "signature": "Handtekening",
      "submit": "Dien In"
    },
    "status": {
      "admin": {
        "addStatus": "Voeg status by",
        "statuses": "Statusse",
        "openEndedResponse": "Oop Einde Reaksie",
        "otherStatus": "Ander _______"
      }
    },
    "submit": "Dien In",
    "resubmit": "Dien Weer In",
    "saveDraft": "Stoor as konsep",
    "types": {
      "COUNTER": "Teltoonbank",
      "QUICK_CONFIRM": "Vinnige Bevestig",
      "STATUS": "Status",
      "WORKFLOW": "Mini Vorm"
    },
    "update": "Dateer Op",
    "workflow": {
      "admin": {
        "page": {
          "addQuestion": "Voeg Vraag By",
          "duplicateQuestion": "Dupliseer Vraag",
          "instructions": "Instruksies",
          "page": "Bladsy {{page}}",
          "questionType": "Vraag Tipe"
        },
        "question": {
          "addOption": "Voeg opsie by",
          "exception": {
            "HasResponse": "Het Reaksie",
            "MissingResponse": "Ontbrekende Reaksie",
            "Off": "Af",
            "label": "Uitsondering hantering:"
          },
          "instructions": "Instruksies",
          "multiline": "Meerregelig",
          "options": "Opsies",
          "question": "Vraag {{question}}"
        },
        "routine": {
          "label": "Roetine",
          "select": "Kies 'n roetine"
        }
      },
      "execution": {
        "optional": "Opsioneel",
        "submit": "Dien In"
      },
      "questionTypes": {
        "CHECKBOX": "Multi-Kies",
        "COUNTER": "Teltoonbank",
        "MEDIA": "Media",
        "QUICK_CONFIRM": "Vinnige Bevestig",
        "RADIO": "Enkel-Kies",
        "ROUTINE": "Roetine",
        "SIGNATURE": "Handtekening",
        "STATUS": "Status",
        "TEXT": "Teks",
        "TIME": "Tyd",
        "LABEL": "Etiket"
      }
    },
    "textEmpty": "Geen roetines",
    "addToGroups": "Voeg by Groepe",
    "addToGroupsDescription": "Wys {{count}} gekose roetines aan groepe toe",
    "list": {
      "name": "Naam",
      "type": "Tipe",
      "groups": "Groepe"
    }
  },
  "saveChanges": "Stoor Veranderinge",
  "unsavedChanges": {
    "title": "Ongestoorde veranderinge",
    "subtitle": "Wil jy jou vordering stoor voordat jy voortgaan?",
    "saveAndExit": "Stoor en verlaat",
    "dontSave": "Moenie stoor nie"
  },
  "signOut": "Teken Uit",
  "support": {
    "genericDescription": "Soms gebeur daar hikke, maar as jy hierdie bladsy weer sien, laat ons asseblief weet sodat ons dit reg kan maak!",
    "sendEmail": "Of e-pos my by",
    "title": "Sjoe, ons het 'n fout gemaak"
  },
  "tags": {
    "assetName": "Batenaam",
    "batches": {
      "title": "Bestellings"
    },
    "status": "Status",
    "tagCode": "Etiket Nommer",
    "title": "Etikette",
    "updatedAt": "Opgedateer Op",
    "version": "Weergawe"
  },
  "textEmptyList": "Geen data",
  "topNav": {
    "activities": "Aktiwiteit",
    "add": "Voeg By",
    "assetInfo": "Bekyk Bate",
    "assets": "Bates",
    "back": "Terug",
    "backButton": {
      "cancel": "Gaan voort met redigering",
      "confirmBack": "Daar is ongestoorde veranderinge!",
      "ok": "Gaan uit sonder om te stoor"
    },
    "cancel": "Kanselleer",
    "customAlert": {
      "cancel": "Kanselleer",
      "deleteAccount": "Is jy seker jy wil jou rekening skrap?",
      "exit": "Gaan uit sonder om te stoor?",
      "signOut": "Is jy seker jy wil uitteken?",
      "yes": "Ja",
      "saveProgress": "Bêre vir later.."
    },
    "edit": "Wysig",
    "editAsset": "Bate Inligting",
    "invite": "Nooi Mense",
    "moreAssetInfo": "Meer Bate Inligting",
    "save": "Stoor",
    "myHistory": "My Geskiedenis",
    "modify": "Wysig"
  },
  "translation": {
    "seeOriginal": "Sien Oorspronklike",
    "seeTranslation": "Sien Vertaling"
  },
  "versionCheck": {
    "description": "Opdaterings beskikbaar! Sommige kenmerke mag nie werk totdat jy die blaaier verfris nie.",
    "refreshButton": "Verfris"
  },
  "offline": {
    "banner": {
      "title": "Jy is vanlyn"
    }
  },
  "workspace": {
    "filter": {
      "searchPlaceholder": "Soek naam",
      "columnButton": "Kolomme",
      "tierButton": "Intekening",
      "columnSelection": "Kolomme",
      "tierSelection": "Intekening",
      "columns": {
        "name": "Naam",
        "owner": "Administrateur",
        "type": "Tipe",
        "subscriptionTierId": "Intekening",
        "assetsCount": "Bates",
        "routinesCount": "Roetines",
        "alerts": "Waarskuwings",
        "peopleCount": "Mense",
        "activitiesCount": "Aktiwiteite",
        "groupsCount": "Groepe",
        "createdAt": "Geskep Op",
        "createdDate": "Geskep Datum",
        "createdTime": "Geskep Tyd",
        "createdBy": "Geskep Deur",
        "lastScanned": "Laaste Geskandeer",
        "lastScannedDate": "Laaste Geskandeer Datum",
        "lastScannedTime": "Laaste Geskandeer Tyd",
        "updatedAt": "Laaste Opgedateer",
        "updatedDate": "Laaste Opgedateer Datum",
        "updatedTime": "Laaste Opgedateer Tyd",
        "lastActivity": "Laaste Aktiwiteit",
        "lastActivityDate": "Laaste Aktiwiteit Datum",
        "lastActivityTime": "Laaste Aktiwiteit Tyd"
      }
    },
    "types": {
      "PRODUCER": "Produsent",
      "OEM": "OEM"
    },
    "create": {
      "addButton": "Dien In",
      "administratorEmail": "Administrateur E-pos",
      "administratorPhone": "Administrateur Telefoonnommer",
      "administratorFirstName": "Administrateur Voornaam",
      "administratorLastName": "Administrateur Van",
      "copyRoutines": "Kopieer Roetines",
      "title": "Skep Werkspasie",
      "validation": {
        "admin_email_required": "Administrateur e-pos is vereis",
        "admin_first_name_required": "Administrateur voornaam is vereis",
        "admin_last_name_required": "Administrateur van is vereis",
        "name_required": "Werkspasie naam is vereis",
        "valid_emil": "Administrateur e-pos moet 'n geldige e-posadres wees"
      },
      "type": "Tipe",
      "workspaceName": "Werkspasie Naam",
      "name": "Werkspasie Naam"
    },
    "createButton": "Skep Werkspasie",
    "menu": {
      "editWorkspace": "Wysig Werkspasie"
    },
    "deleteWorkspace": {
      "deleteWorkspace": "Skrap Werkspasie",
      "alertBody1": "Is jy seker jy wil skrap",
      "alertBody2": "Let wel: ",
      "alertBody3": "Dit sal nie enige bates wat met hierdie ",
      "alertBody4": "werkspasie geassosieer is skrap nie.",
      "delete": "Skrap",
      "cancel": "Kanselleer"
    },
    "list": {
      "name": "Naam",
      "owner": "Administrateur",
      "type": "Tipe",
      "assetsCount": "Bates",
      "routinesCount": "Roetines",
      "alerts": "Waarskuwings",
      "peopleCount": "Mense",
      "activitiesCount": "Aktiwiteite",
      "groupsCount": "Groepe",
      "createdAt": "Geskep Op",
      "createdDate": "Geskep Datum",
      "createdTime": "Geskep Tyd",
      "createdBy": "Geskep Deur",
      "lastScanned": "Laaste Geskandeer",
      "lastScannedDate": "Laaste Geskandeer Datum",
      "lastScannedTime": "Laaste Geskandeer Tyd",
      "updatedAt": "Laaste Opgedateer",
      "updatedDate": "Laaste Opgedateer Datum",
      "updatedTime": "Laaste Opgedateer Tyd",
      "lastActivity": "Laaste Aktiwiteit",
      "lastActivityDate": "Laaste Aktiwiteit Datum",
      "lastActivityTime": "Laaste Aktiwiteit Tyd"
    }
  },
  "permissions": {
    "backButton": "Terug",
    "continueButton": "Gaan Voort",
    "enableInSettings": "Jy moet hierdie toestemming in die stelselmenu aktiveer om voort te gaan.",
    "openSetting": "Maak Instellings Oop",
    "welcome": {
      "title": "Welkom by Gripp!",
      "description1": "Om Gripp te gebruik, moet ons verskeie toestemmings aktiveer.",
      "description2": "Ons sal jou deur elkeen lei om te verduidelik waarom ons dit nodig het.",
      "description3": "Alle instellings kan te eniger tyd deur jou foon se instellings aangepas word."
    },
    "location": {
      "initial": {
        "title": "Toegang tot jou ligging, om jou bates op te spoor.",
        "description1": "Gripp gebruik jou foon se ligging om die ligging van jou bates op te dateer wanneer jy hulle skandeer.",
        "description2": "Minimaal vra ons jou om ligging toe te laat terwyl jy die toep gebruik."
      },
      "denied": {
        "title": "Liggingstoegang, om jou bates op te spoor.",
        "description1": "Ligging help om jou bates te volg."
      },
      "button": "Gaan Voort"
    },
    "camera": {
      "initial": {
        "title": "Toegang tot jou kamera, om vas te lê, boodskap te stuur & te rapporteer.",
        "description1": "Notas maak en kwessies rapporteer vereis dikwels dat jy 'n foto neem van wat jy sien, so om kameratoegang te aktiveer is belangrik om foto's te neem!"
      },
      "denied": {
        "title": "Kameratoegang, om vas te lê, boodskap te stuur & te rapporteer.",
        "description1": "Kameratoegang laat jou toe om kwessies maklik vas te lê en te rapporteer!"
      },
      "button": "Gaan Voort"
    },
    "gallery": {
      "initial": {
        "title": "Toegang tot jou fotogalery, om foto's op te laai.",
        "description1": "Soortgelyk aan kamera, het jy soms reeds foto's wat jy in Gripp wil oplaai.",
        "description2": "Gripp sal slegs toegang hê tot die foto's wat jy kies op die punt van oplaai."
      },
      "denied": {
        "title": "Fotogalery toegang, om foto's op te laai.",
        "description1": "Galerytoegang laat jou toe om die foto's wat jy kies op te laai."
      },
      "button": "Gaan Voort"
    },
    "notification": {
      "initial": {
        "title": "Bly op hoogte met kennisgewings.",
        "description1": "Word in kennis gestel wanneer 'n nuwe waarskuwing, kwessie of verslag deurkom."
      },
      "denied": {
        "title": "Kennisgewings, om op datum te bly.",
        "description1": "Kry span waarskuwings, kwessies en verslae—geen bemarkings boodskappe nie."
      },
      "button": "Gaan Voort"
    },
    "allSet": "Alles gereed, kom ons begin Gripp!"
  },
  "routine": {
    "list": {
      "name": "Naam",
      "type": "Roetine Tipe",
      "groups": "Groepe",
      "routines": "Roetines",
      "oldRoutines": "Ou Roetines",
      "asset": {
        "name": "Naam",
        "description": "Beskrywing",
        "groups": "Groepe"
      }
    },
    "filter": {
      "searchPlaceholder": "Soek roetienaam",
      "columnButton": "Kolomme",
      "columnSelection": "Kolomme",
      "columns": {
        "name": "Naam",
        "type": "Roetine Tipe",
        "assetsCount": "Bates",
        "addonsCount": "Byvoegings",
        "allAssetsCount": "Alle Bates",
        "submissionsCount": "Indienings",
        "groups": "Groepe",
        "lastSubmitted": "Laaste Ingedien",
        "updatedAt": "Laaste Gewysig",
        "createdAt": "Datum Geskep"
      }
    },
    "rowHeader": {
      "routineSelected": "1 roetine gekies",
      "routinesSelected": "{{count}} roetines gekies"
    },
    "permittedRoles": {
      "label": "Toegelate Rolle",
      "noRoles": "Geen rolle beskikbaar nie"
    }
  },
  "product": {
    "change": "Verander",
    "list": {
      "products": "Produkte",
      "name": "Naam",
      "description": "Beskrywing",
      "assetsCount": "Bates",
      "filesCount": "Lêers",
      "addonsCount": "Byvoegings",
      "routines": "Roetines",
      "alerts": "Bate Waarskuwings",
      "productAlerts": "Produk Waarskuwings",
      "createdAt": "Geskep Op",
      "updatedAt": "Laaste Opgedateer"
    },
    "filter": {
      "searchPlaceholder": "Soek produknaam",
      "columnButton": "Kolomme",
      "columns": {
        "name": "Naam",
        "description": "Beskrywing",
        "assetsCount": "Bates",
        "filesCount": "Lêers",
        "addonsCount": "Byvoegings",
        "routines": "Roetines",
        "alerts": "Bate Waarskuwings",
        "productAlerts": "Produk Waarskuwings",
        "createdAt": "Geskep Op",
        "updatedAt": "Laaste Opgedateer"
      },
      "columnSelection": "Kolomme"
    },
    "create": {
      "label": "Skep 'n Nuwe Produk",
      "validation": {
        "name_required": "Produknaam is vereis"
      },
      "cancel": "Kanselleer",
      "create": "Skep",
      "placeholder": "bv. Produk 1"
    },
    "delete": {
      "button": "Skrap Produk",
      "cancel": "Kanselleer",
      "confirm": "Ja",
      "title": "Is jy seker jy wil die produk {{productName}} skrap?"
    },
    "detail": {
      "addon_options": "Byvoeging Opsies",
      "no_addon_options": "Daar is geen byvoeging opsies vir hierdie produk nie.",
      "add_more": "Voeg meer by",
      "description": "Beskrywing",
      "details": "Besonderhede",
      "files": {
        "placeholder": "Enige bykomende lêers om op te laai? (databorde, oem-plakkers, ens.)",
        "addFilesLinks": "Voeg lêers / skakels by"
      },
      "save": "Stoor",
      "cancel": "Kanselleer",
      "profile": "Produk Profiel",
      "assets": "Bates",
      "routines": "Roetines",
      "noAvailableRoutines": "Geen beskikbare roetines om by te voeg",
      "edit": "Wysig",
      "delete": "Skrap",
      "confirmDelete": "Is jy seker jy wil die produk {{fileName}} skrap?"
    },
    "specifications": {
      "title": "Alle Spesifikasies",
      "upload": "Laai Data Op",
      "download": "Laai Af",
      "add_more": "Voeg meer by",
      "label_placeholder": "Spesifikasie naam",
      "value_placeholder": "Waarde",
      "delete_confirm": "Is jy seker jy wil hierdie spesifikasie skrap?",
      "upload_coming_soon": "CSV oplaai funksionaliteit kom binnekort",
      "download_coming_soon": "CSV aflaai funksionaliteit kom binnekort",
      "upload_success": "Spesifikasies suksesvol opgelaai",
      "upload_error": "Kon nie spesifikasies oplaai nie. Probeer asseblief weer.",
      "download_error": "Kon nie spesifikasies aflaai nie. Probeer asseblief weer.",
      "download_title": "Laai Spesifikasies Af",
      "no_data_to_download": "Geen spesifikasies om af te laai",
      "sharing_not_available": "Lêerdeling is nie beskikbaar op hierdie toestel nie"
    },
    "assignments": {
      "assets": "Bates",
      "routines": "Roetines",
      "files": "Lêers",
      "addons": "Byvoegings",
      "searchPlaceholder": "Soek naam",
      "assetSearchPlaceholder": "Soek batenaam",
      "routineSearchPlaceholder": "Soek roetienaam",
      "fileSearchPlaceholder": "Soek lêernaam",
      "addonSearchPlaceholder": "Soek byvoeging naam"
    }
  },
  "file": {
    "list": {
      "files": "Lêers",
      "name": "Naam",
      "products": "Produkte",
      "assets": "Bates",
      "addons": "Byvoegings",
      "categories": "Kategorieë",
      "lastUpdated": "Laaste Opgedateer",
      "createdAt": "Geskep Op"
    },
    "filter": {
      "searchPlaceholder": "Soek lêernaam",
      "columnButton": "Kolomme",
      "categories": "Kategorieë",
      "searchCategories": "Soek kategorieë",
      "deleteCategory": "Skrap Kategorie",
      "deleteCategoryMessage": "Is jy seker jy wil \"{{categoryName}}\" skrap? Dit sal die kategorie van {{fileCount}} lêers verwyder.",
      "columns": {
        "name": "Naam",
        "productsCount": "Produkte",
        "assetsCount": "Bates",
        "addonsCount": "Byvoegings",
        "categories": "Kategorieë",
        "updatedAt": "Laaste Opgedateer",
        "createdAt": "Geskep Op"
      },
      "columnSelection": "Kolomme"
    },
    "assignments": {
      "productsSearchPlaceholder": "Soek produknaam",
      "addonsSearchPlaceholder": "Soek byvoeging naam"
    },
    "create": {
      "label": "Voeg Lêer By",
      "linkLabel": "Voeg Skakel By",
      "title": "Titel",
      "linkUrl": "Skakel URL",
      "category": "Kategorie",
      "file": "Lêer (slegs een lêer)",
      "link": "Skakel (slegs een skakel)",
      "add": "Voeg By",
      "addLink": "Voeg Skakel By",
      "titlePlaceholder": "Voer lêertitel in",
      "linkUrlPlaceholder": "Voer URL in (bv., https://example.com)",
      "categoryPlaceholder": "Kies kategorieë",
      "categorySearchPlaceholder": "Soek kategorieë",
      "createCategory": "Skep Kategorie",
      "selectCategory": "Kies kategorieë",
      "searchCategory": "Soek kategorieë",
      "emptyStateMessage": "Skep 'n kategorie deur direk in die soekbalk te tik.",
      "clickToUpload": "Klik om lêer op te laai",
      "linkPlaceholder": "Voer URL in (bv., https://example.com)",
      "validation": {
        "title_required": "Lêertitel is vereis",
        "category_required": "Ten minste een kategorie is vereis",
        "link_required": "Skakel URL is vereis",
        "link_invalid": "Voer asseblief 'n geldige URL in"
      },
      "uploadError": "Kon nie lêer oplaai nie. Probeer asseblief weer.",
      "linkError": "Kon nie skakel skep nie. Probeer asseblief weer."
    },
    "dropdown": {
      "createFile": "Skep Lêer",
      "file": "Lêer",
      "link": "Skakel"
    },
    "tabs": {
      "products": "Produkte",
      "addons": "Byvoegings"
    },
    "deleteFile": {
      "deleteFile": "Skrap Lêer",
      "alertBody1": "Is jy seker jy wil skrap",
      "delete": "Skrap",
      "cancel": "Kanselleer"
    },
    "assets": {
      "title": "Bates",
      "name": "Naam",
      "description": "Beskrywing",
      "lastScanned": "Laaste Geskandeer",
      "lastAddress": "Laaste Adres",
      "lastUpdated": "Laaste Opgedateer",
      "noAssets": "Geen bates gevind"
    }
  },
  "addOn": {
    "list": {
      "addOns": "Byvoegings",
      "name": "Naam",
      "product": "Produkte",
      "asset": "Bates",
      "media": "Lêers",
      "routines": "Roetines",
      "createdAt": "Geskep Op",
      "updatedAt": "Laaste Opgedateer",
      "addon": "Byvoeging"
    },
    "filter": {
      "searchPlaceholder": "Soek byvoeging naam",
      "columnButton": "Kolomme",
      "columns": {
        "name": "Naam",
        "product": "Produkte",
        "asset": "Bates",
        "media": "Lêers",
        "routines": "Roetines",
        "createdAt": "Geskep Op",
        "updatedAt": "Laaste Opgedateer"
      },
      "columnSelection": "Kolomme"
    },
    "create": {
      "label": "Skep Byvoeging",
      "validation": {
        "name_required": "Byvoeging naam is vereis"
      },
      "cancel": "Kanselleer",
      "create": "Skep",
      "placeholder": "bv. Byvoeging 1"
    },
    "assignment": {
      "productSearchPlaceholder": "Soek produknaam",
      "mediaSearchPlaceholder": "Soek lêernaam",
      "routineSearchPlaceholder": "Soek roetienaam",
      "success": "Produkte suksesvol aan byvoeging toegewys",
      "error": "Moet produk ID's verskaf"
    },
    "files": {
      "title": "Lêers",
      "name": "Naam",
      "type": "Tipe",
      "extension": "Uitbreiding",
      "textEmpty": "Geen lêers gevind",
      "addFilesLinks": "Voeg lêers / skakels by",
      "save": "Stoor",
      "delete": "Skrap",
      "list": {
        "name": "Naam",
        "categories": "Kategorieë"
      }
    },
    "textEmpty": "Tik '+ Skep Byvoeging' om jou eerste byvoeging by te voeg.",
    "edit": {
      "label": "Wysig Byvoeging",
      "save": "Stoor"
    },
    "deleteAddon": "Verwyder Byvoeging"
  },
  "labels": {
    "confirmTextLine1": "Is jy seker jy wil die \"{{labelName}}\" etiket skrap?",
    "confirmTextLine2": "Dit sal die etiket van {{activityCount}} bestaande aktiwiteite verwyder.",
    "cancel": "Kanselleer",
    "delete": "Skrap",
    "editLabels": "Wysig Etikette",
    "labels": "Etikette",
    "yes": "Ja"
  },
  "categories": {
    "confirmTextLine1": "Is jy seker jy wil die \"{{categoryName}}\" kategorie skrap?",
    "confirmTextLine2": "Dit sal die kategorie van {{fileCount}} bestaande lêers verwyder.",
    "cancel": "Kanselleer",
    "delete": "Skrap",
    "editCategories": "Wysig Kategorieë",
    "categories": "Kategorieë",
    "yes": "Ja"
  }
}